import React from 'react';
import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions';
import _ImpactHubButtonAnchor from "ImpactHubButton-ImpactHubButtonAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ImpactHubButton.tsx?styleId=ImpactHubButtonAnchor";
import _IconContainer from "ImpactHubButton-IconContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ImpactHubButton.tsx?styleId=IconContainer";


const ImpactHubButtonAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "ImpactHubButtonAnchor",
  styles: _ImpactHubButtonAnchor
});

const IconContainer = /*#__PURE__*/styled("div", null, {
  displayName: "IconContainer",
  styles: _IconContainer
});

const ImpactHubButton = () => {
  const url = '/impact?from_navbar=true&trigger=nav';

  return (
    <ImpressionWatcher source="impact_hub_nav_button">
      <ImpactHubButtonAnchor href={url}>
        <IconContainer>
          <Icon name="whatshot" size={22} />
        </IconContainer>
        Impact Hub
      </ImpactHubButtonAnchor>
    </ImpressionWatcher>
  );
};

export default ImpactHubButton;
